import React from 'react'
import ContextWrapper from './ContextWrapper'
import { useResume } from './ResumeProvider'

const StandaloneViewer = ({ ...props }) => {
  return (
    <ContextWrapper {...props}>
      <div id="resume-pdf-preview" className="relative md:flex-grow">
        <div className="w-full md:sticky md:left-0 md:top-0 md:h-screen">
          <PdfViewer />
        </div>
      </div>
    </ContextWrapper>
  )
}
export default StandaloneViewer

const PdfViewer = () => {
  const {
    pdf: { url, loading },
  } = useResume()

  if (loading) {
    return null
  }
  return (
    <iframe
      src={`${url}#navpanes=0`}
      className="h-full w-full"
      title="Resume Preview"
      frameBorder="0"
      loading="lazy"
    />
  )
}
